import Information from './Information'
import Setting from './Setting'

const Colocation = {
    Information,
    Setting,
}

export default Colocation
